import { getBrandColor } from "../../lib/brandColors";
import getTechIcon from "../../lib/techIcons";
import { useTheme } from "../../theme/ThemeContext";

// A LeetCode-style topic tag. Clickable variant used for filters.
// `colorIcon` tints the glyph with its brand color (adaptive in dark mode).
const TopicPill = ({
  name,
  showIcon = true,
  count,
  active = false,
  onClick,
  size = "md",
  colorIcon = false,
}) => {
  const Icon = getTechIcon(name);
  const { mode } = useTheme();
  const brand = colorIcon ? getBrandColor(name, mode) : null;
  const className = `topic-pill topic-pill-${size}${active ? " is-active" : ""}${
    onClick ? " is-clickable" : ""
  }`;

  const content = (
    <>
      {showIcon && (
        <span
          className="topic-pill-icon"
          style={brand ? { color: brand } : undefined}
        >
          <Icon />
        </span>
      )}
      <span className="topic-pill-name">{name}</span>
      {count != null && <span className="topic-pill-count">{count}</span>}
    </>
  );

  if (onClick) {
    return (
      <button type="button" className={className} onClick={onClick}>
        {content}
      </button>
    );
  }
  return <span className={className}>{content}</span>;
};

export default TopicPill;
